<template>
  <div>
    <details-modal
      :show="show"
      :current-operation="currentOperation"
      @close="closeModal"
      @cancel="closeModal"
      @create="createProfileButtonClicked"
      @delete="deleteProfileButtonClicked"
    >
      <form class="text-left">
        <profile-category-select
          v-validate="'required'"
          v-if="currentOperation === 'create'"
          v-model="profile.profileCategory"
          title="Catégorie du thème *"
          data-vv-scope="formProfileDetails"
          name="catégorie du thème"
          required
          @input="profileCategorySelectedEvent"
        />
        <div v-else>
          <p>Catégorie du thème</p>
          <p class="profile-detail">{{ profile.profileCategory }}</p>
        </div>
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first(`formProfileDetails.catégorie du thème`) }}
        </div>
        <profile-name-select
          v-validate="'required'"
          v-if="currentOperation === 'create'"
          v-show="profile.profileCategory"
          :profile-category.sync="profile.profileCategory"
          v-model="profile.profileId"
          title="Nom du thème *"
          data-vv-scope="formProfileDetails"
          name="nom du thème"
          required
        />
        <div v-else>
          <p>Nom du thème</p>
          <p class="profile-detail">{{ profile.profileName }}</p>
        </div>
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first(`formProfileDetails.nom du thème`) }}
        </div>
        <p v-if="currentOperation === 'create'" class="mt-3 mb-0">
          <label>* champs obligatoires</label>
        </p>
      </form>
      <p v-if="errorMessage" class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import ProfileCategorySelect from 'src/components/ApplicationViews/UIComponents/ProfileCategorySelect';
import ProfileNameSelect from 'src/components/ApplicationViews/UIComponents/ProfileNameSelect';
import DetailsModal from './DetailsModal.vue';

export default {
  components: {
    ProfileCategorySelect,
    ProfileNameSelect,
    DetailsModal,
  },
  props: {
    show: Boolean,
    currentOperation: String,
    profile: Object,
    linkedEntityId: Number,
    // Either "people" or "institutions", will change the URIs and show/hide the "type" field.
    type: String,
  },
  data() {
    return {
      personType: 'people',
      errorMessage: '',
    };
  },
  methods: {
    createProfileButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formProfileDetails').then(result => {
        if (result) {
          this.errorMessage = null;

          const data = {
            profileId: this.profile.profileId,
          };

          if (this.type === this.personType) {
            data.personId = this.linkedEntityId;
          } else {
            data.institutionId = this.linkedEntityId;
          }

          this.$http
            .post(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/${this.type}/profiles/`,
              data,
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              if (error.response.status === 409) {
                this.errorMessage =
                  'La personne est déjà associée avec ce thème.';
              } else {
                this.errorMessage =
                  "Une erreur est survenue l'ajout du thème, veuillez réessayer ou contacter le support.";
              }
            });
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs.';
        }
      });
    },
    deleteProfileButtonClicked() {
      this.errorMessage = null;

      swal({
        title: 'Êtes-vous sûr de vouloir supprimer ce thème ?',
        text: "Il ne sera pas possible d'annuler cette suppression",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      })
        .then(() => {
          this.$http
            .delete(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/${this.type}/profiles/${this.linkedEntityId}/${this.profile.profileId}`,
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              this.errorMessage =
                'Une erreur est survenue lors de la suppression du thème, veuillez réessayer ou contacter le support.';
            });
        })
        .catch(() => {});
    },
    profileCategorySelectedEvent(input, event) {
      this.profile.profileId = null;
    },
    closeModal() {
      this.$emit('close');
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped>
.validation-error {
  color: red;
  margin-bottom: 1em;
}

.profile-detail {
  border-color: #51bcda !important;
  border-width: 2px;
  border-radius: 20px;
  color: #51bcda;
}
</style>
